import React, { PropsWithChildren } from "react";
import NukaCarousel, { CarouselProps } from "nuka-carousel";
import cx from "classnames";
import { useBreakpoints } from "@common/hooks";
import { HiOutlineArrowLeft, HiOutlineArrowRight } from "react-icons/hi";
import { themeTextColors } from "@common/constants";

const Carousel: React.FC<
  PropsWithChildren<CarouselProps & { className?: string }>
> = ({ children, ...props }) => {
  const { isMobile } = useBreakpoints();

  return (
    <NukaCarousel
      className="relative bg-gray-100"
      wrapAround
      animation="zoom"
      zoomScale={0.5}
      renderBottomCenterControls={(props) => {
        // dots become crowded and janky on mobile with too many items:
        const hidePagingDots = isMobile && props.pagingDotsIndices.length > 5;
        return (
          <div className={cx({ hidden: hidePagingDots })}>
            {props.pagingDotsIndices.map((dot) => {
              const isActive = dot === props.currentSlide;
              return (
                <button
                  key={dot}
                  className={cx(
                    "mx-2 mb-3 mt-2 h-2 w-2 rounded-full",
                    isActive ? "bg-gray-400" : "bg-white"
                  )}
                  onClick={() => props.goToSlide(dot)}
                />
              );
            })}
          </div>
        );
      }}
      defaultControlsConfig={{
        nextButtonText: (
          <div className="rounded-full bg-white p-3">
            <HiOutlineArrowRight color={themeTextColors.primary} size={24} />
          </div>
        ),
        nextButtonStyle: {
          borderRadius: "50%",
          background: "none",
          right: 2,
          position: "relative",
        },
        prevButtonText: (
          <div className="rounded-full bg-white p-3">
            <HiOutlineArrowLeft color={themeTextColors.primary} size={24} />
          </div>
        ),
        prevButtonStyle: {
          background: "none",
          borderRadius: "50%",
          left: 2,
          position: "relative",
        },
        ...props.defaultControlsConfig,
      }}
      {...props}
    >
      {React.Children.map(children, (child) => {
        return (
          <div className="flex justify-center">
            {React.cloneElement(child as React.ReactElement)}
          </div>
        );
      })}
    </NukaCarousel>
  );
};

export default Carousel;
